import { Languages } from "lucide-react";
import { lang, setLang } from "@/lib/i18n";

/** Переключатель языка интерфейса RU/EN (страница перезагружается). compact — только код языка. */
export default function LangToggle({ compact = false }: { compact?: boolean }) {
  const next = lang === "en" ? "ru" : "en";
  const label = lang === "en" ? "Переключить на русский" : "Switch to English";
  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      title={label}
      aria-label={label}
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-btn border border-border px-2.5 py-2 text-xs font-semibold text-muted-foreground transition hover:border-primary/60 hover:text-primary"
    >
      <Languages className="size-4 flex-none" aria-hidden />
      <span className={compact ? "" : "hidden sm:inline"}>{next.toUpperCase()}</span>
    </button>
  );
}
